import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M15.5 15.6664C15.5 16.1267 15.1269 16.4998 14.6667 16.4998H1.33333C0.8731 16.4998 0.5 16.1267 0.5 15.6664V6.90735C0.5 6.65019 0.618725 6.40744 0.821717 6.24956L7.48842 1.06438C7.78933 0.830327 8.21067 0.830327 8.51158 1.06438L15.1782 6.24956C15.3812 6.40744 15.5 6.65019 15.5 6.90735V15.6664ZM13.8333 14.8331V7.31493L8 2.77789L2.16667 7.31493V14.8331H13.8333ZM3.83333 11.4998H12.1667V13.1664H3.83333V11.4998Z"
	})
});
export default SvgHome;
